<template>
  <div>
    <pageTable
                ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :showSearchForm="false"
               :showPage="false"
               tableApi="admin/company/getCompanyStationTaskInfo"
    >
    </pageTable>
  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'
  export default {
    name: "companyStation",
    components:{pageTable},
    props:{
      taskId:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        searchData:{
          task_id:this.taskId,
        },
        multiPrice:'',
        do_time:'',
        doingMultiSet:false,
        tableColumn: [
          {title: '编号',type: 'index',align: "center",width:80},
          {title: '站点ID',key: 'station_id',align: "center"},
          {title: '站点名称',key: 'gas_name',align: "center",render:(h,params)=>{
              return h('div',[
                h('p',params.row.gas_name),
                h('Tag',{props:{color:'orange'}},params.row.is_bill===1 ? 'A型' : 'B型'),
              ])
            }},
          {title: '更新时间',key: 'update_time',width:180,align: "center"},
          {title: '价格',key: 'price',align: "left",width:200,render:(h,params)=>{
            return h('div',[
              h('p',`A型 : ${params.row.price2}`),
              h('p',`B型 : ${params.row.no_bill_price}`),
              h('p',`车队价格 : ${params.row.has_company_price === 1 ? params.row.company_price : '未设置'}`),
            ])
            }},
          {title: '价格/零售价',align: "center",width:200,render:(h,params)=>{
            return h('div',`${params.row.new_company_price} / ${params.row.new_retail_prices}`)
            }},
        ],
      }
    },
    methods:{

    }
  }
</script>

<style scoped>

</style>